export const FLOW_ID_HEADER = 'x-civic-flowId';
export const EXTERNAL_USER_ID_HEADER = 'X-External-User-ID';
export const USER_TOKEN_HEADER = 'Authorization';
